import React from 'react';
import { StyledHeaderDirectory, StyledHeaderItem } from './style';

const HeaderData = [
  'Emisora',
  'Texto',
  'Pos.',
  'Pedido',
  'Precio',
  'Fecha',
  'Código SAP',
  'Provedor'
];

const HeaderDirectory = () => (
  <StyledHeaderDirectory>
    {HeaderData.map((item, i) => (
      <StyledHeaderItem key={`header-g-${i + 1}`}>{item}</StyledHeaderItem>
    ))}
  </StyledHeaderDirectory>
);

export default HeaderDirectory;
